import type { ReactElement } from 'react';
import { useRef } from 'react';

import { ApiRoute } from 'config';
import { get } from 'utils/network';
import useAsyncEffect from 'hooks/useAsyncEffect';
import { IOrderHistory } from '../../models/OrderHistory';
import OrderHistoryMenu from '../../models/OrderHistoryMenu';

function TrackingPage(): ReactElement {
  const shipupContainerRef = useRef();

  useAsyncEffect(async (isMounted) => {
    const response = await get<IOrderHistory[]>(ApiRoute.ORDER_HISTORY);
    if (isMounted.current && response.ok) {
      const { orders } = response.parsedBody as unknown as { orders: OrderHistoryMenu[] };
      let trackingNumber;
      if (orders?.length > 0) {
        const trackableOrder = orders.find((order) => {
          const deliveryOn = new Date(order.delivery_on);
          const oneWeekAgo = new Date(Date.now());
          oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
          return (
            order.fulfillment_status === 'confirmed'
              && order.shipments[0]?.tracking_number !== null
              && deliveryOn > oneWeekAgo
          );
        });
        trackingNumber = trackableOrder ? trackableOrder.shipments[0]?.tracking_number : undefined;
      }

      const ShipupJS = window.ShipupJS.default;
      const shipupElement = shipupContainerRef.current;
      const shipup = new ShipupJS(window.SHIPUP_PUBLIC_ACCESS_KEY);

      shipup.render(shipupElement, {
        language: 'en',
        searchEnabled: true,
        trackingNumber,
      });
    }
  }, []);

  return (
    <div className="col-lg-10" data-fragment="tracking-show">
      <div className="c-profile" data-fragment="tracking-show">
        <h1 className="c-heading c-heading--center c-heading--brand-4">
          Track Package
        </h1>

        <div
          id="shipup-container"
            // @ts-expect-error TODO: fix null safety
          ref={shipupContainerRef}
        />
      </div>
    </div>
  );
}

export default TrackingPage;
